/* src/modules/locations/action_types.js */

export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_FAIL = 'FETCH_LOCATIONS_FAIL';

export const ADD_LOCATION = 'ADD_LOCATION';
export const ADD_LOCATION_SUCCESS = 'ADD_LOCATION_SUCCESS';
export const ADD_LOCATION_FAIL = 'ADD_LOCATION_FAIL';

export const addLocationToUniversityTypes = [
  'ADD_LOCATION_TO_UNIVERSITY',
  'ADD_LOCATION_TO_UNIVERSITY_SUCCESS',
  'ADD_LOCATION_TO_UNIVERSITY_FAIL',
];

export const addInterviewLocationTypes = [
  'ADD_INTERVIEW_LOCATION',
  'ADD_INTERVIEW_LOCATION_SUCCESS',
  'ADD_INTERVIEW_LOCATION_FAIL',
];

export const editLocationTypes = [
  'EDIT_LOCATION',
  'EDIT_LOCATION_SUCCESS',
  'EDIT_LOCATION_FAIL',
];

export const removeLocationTypes = [
  'REMOVE_LOCATION',
  'REMOVE_LOCATION_SUCCESS',
  'REMOVE_LOCATION_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/locations/action_types.js